import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId,
    contract,
    checkbox4,
    checkbox5,
    taxId2,
    taxId3,
    moneyType,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [certificate.name]: "",
  [moneyType.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
  [taxCalculationPeriod.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxpayerName.name]: "",
  [taxId.name]: "",
  [contract.name]: "",
  [checkbox4.name]: false,
  [checkbox5.name]: false,
  [taxId2.name]: "",
  [taxId3.name]: "",
};

export default initialValues;
